import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-ink-900 text-ink-200">
      <div className="max-w-8xl mx-auto px-6 md:px-10 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <Link to="/en/home" className="inline-block">
            <img
              src={`${process.env.PUBLIC_URL}/images/zz.png`}
              alt="Linkakam"
              className="w-36"
            />
          </Link>
          <p className="mt-4 text-sm text-ink-400 max-w-xs">
            {t("One link for everything you make, share and sell — free, no paywall on the core tools.")}
          </p>
        </div>

        <nav aria-label={t("Footer navigation")}>
          <h2 className="font-display text-sm uppercase tracking-wide text-white mb-4">
            {t("Explore")}
          </h2>
          <ul className="space-y-3 text-sm">
            <li>
              <Link className="hover:text-white transition-colors" to="/en/home">
                {t("Home")}
              </Link>
            </li>
            <li>
              <Link className="hover:text-white transition-colors" to="/en/about">
                {t("About")}
              </Link>
            </li>
            <li>
              <Link className="hover:text-white transition-colors" to="/en/qrgenrater">
                {t("QR Code Generator")}
              </Link>
            </li>
            <li>
              <Link className="hover:text-white transition-colors" to="/en/contact">
                {t("Contact")}
              </Link>
            </li>
          </ul>
        </nav>

        <div>
          <h2 className="font-display text-sm uppercase tracking-wide text-white mb-4">
            {t("Get in touch")}
          </h2>
          <ul className="space-y-3 text-sm">
            <li>
              <a
                className="hover:text-white transition-colors"
                href="mailto:support@linkakam.com"
              >
                support@linkakam.com
              </a>
            </li>
            <li>
              <a className="hover:text-white transition-colors" href="tel:+9647737330003">
                +964 773 733 0003
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-8xl mx-auto px-6 md:px-10 py-6 text-xs text-ink-400 flex flex-col md:flex-row gap-2 justify-between">
          <p>&copy; {year} Linkakam. {t("All rights reserved.")}</p>
        </div>
      </div>
    </footer>
  );
}
